import { makeStyles } from "tss-react/mui";
import { mdiClose } from "@mdi/js";
import { Box } from "@mui/material";
import { MiButton } from "../../MiButton/MiButton";

export const DatePickerActionBar = ({
  actions = [],
  onCancel,
  onClear,
  onAccept,
  onSetToday,
  className,
  ownerState,
}) => {
  const { error, onReset, secondaryActions = [] } = ownerState.slotProps;
  const { classes } = useStyles({ error });

  if (!actions.length) return null;

  const actionButtons = actions.map((actionType) => {
    const actionConfig = {
      cancel: {
        onClick: onCancel,
        icon: mdiClose,
      },
      reset: {
        onClick: onReset,
        title: "Reset Date",
      },
      clear: {
        onClick: onClear,
        title: "Clear Date",
      },
      today: {
        onClick: onSetToday,
        title: "Set Today",
      },
      accept: {
        onClick: onAccept,
        title: "Accept Date",
      },
    };

    const config = actionConfig[actionType];

    if (!config) return null;

    return (
      <MiButton
        key={actionType}
        onClick={config.onClick}
        startIcon={config.icon ? { path: mdiClose } : null}
        title={config?.title}
      />
    );
  });

  return (
    <Box className={className}>
      <Box className={classes.secondaryActionsContainer}>
        {secondaryActions}
      </Box>
      <Box className={classes.actions}>{actionButtons}</Box>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  secondaryActionsContainer: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
}));
